var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditUnderline = function SvgEditUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "auto",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.99 16.854-1.314 3.504a.752.752 0 0 0 .966.966l3.504-1.314c.402-.15.765-.384 1.068-.687L18.36 9.177s-.354-1.062-1.413-2.121c-1.059-1.059-2.121-1.413-2.121-1.413L4.68 15.789a2.984 2.984 0 0 0-.687 1.068l-.003-.003Zm12.249-12.63 1.383-1.383c.249-.249.579-.405.924-.348.486.081 1.233.321 1.935 1.026.702.702.945 1.446 1.026 1.935.057.345-.099.678-.348.924l-1.383 1.383s-.354-1.059-1.413-2.121c-1.059-1.062-2.121-1.416-2.121-1.416h-.003Z",
    fill: "#04884B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39 19.872a.75.75 0 0 0 0 1.5h11.22a.75.75 0 0 0 0-1.5H9.39Z",
    fill: "#04884B"
  })));
};
export default SvgEditUnderline;